import urlBuilder from '@/helpers/urlBuilder';
import {
  ProjectTask,
  ProjectTaskCreateParams,
  ProjectTaskListFilters,
  ProjectTaskListResponse,
  ProjectTaskUpdateParams,
} from '@/interfaces/projectTask';
import HttpService from './HttpService';

const BASE_URL = `${process.env.VUE_APP_SERVER_URL}/api/projectTasks`;

async function fetchProjectTasks(filters: ProjectTaskListFilters): Promise<ProjectTaskListResponse> {
  const res = await HttpService.getWithLoading(urlBuilder(BASE_URL, { ...filters }));
  return res.data;
}

async function createProjectTask(params: ProjectTaskCreateParams): Promise<ProjectTask> {
  const url = `${BASE_URL}/${params.projectId}/create`;
  const res = await HttpService.postWithLoading(url, params);
  return res.data.entity;
}

async function updateProjectTask(params: ProjectTaskUpdateParams): Promise<ProjectTask> {
  const res = await HttpService.putWithLoading(`${BASE_URL}?taskId=${params.id}`, params);
  return res.data.entity;
}

async function archiveProjectTask(taskId: string): Promise<void> {
  await HttpService.postWithLoading(`${BASE_URL}/archive?taskId=${taskId}`, {});
}

async function fetchUpcomingNotifications(): Promise<{ hasUpcoming: boolean }> {
  const res = await HttpService.get(`${BASE_URL}/upcoming-notifications`);
  return res.data;
}

async function getOrganizationUsers(organizationId: string): Promise<{ email: string; name: string }[]> {
  const res = await HttpService.get(`${BASE_URL}/organization-users`, { params: { organizationId } });
  return res.data;
}

const ProjectTasksService = {
  fetchProjectTasks,
  createProjectTask,
  updateProjectTask,
  archiveProjectTask,
  fetchUpcomingNotifications,
  getOrganizationUsers,
};

export default ProjectTasksService;
